// Services
import breedService from '@/app/services/main/breed/breed-service.js';
import authHealthCheckService from '@/app/services/auth/auth-health-check/auth-health-check-service.js';
import addressFinderAutocompleteService from '@/app/services/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js';

// Constants
import { STATUS_CODES, STATUS_MSG } from '@/app/constants/status-constants';

export default {
    name: 'HealthCheckContainer',
    data() {
        return {
            services: {
                lmdcAPI: {
                    label: 'LMDC API',
                    status: 'Pending',
                    responseTime: 0
                },
                authServiceAPI: {
                    label: 'Auth Service API',
                    status: 'Pending',
                    responseTime: 0
                },
                addressFinderAPI: {
                    label: 'Address Finder API',
                    status: 'Pending',
                    responseTime: 0
                },
            }
        }
    },
    created() {
        this.checkLMDCStatus();
        this.checkAuthServiceStatus();
        this.checkAddressFinderStatus();
    },
    methods: {
        getServiceBadge(status) {
            let className;
            const statusMap = {
                'Success': 'success',
                'Pending': 'warning',
            }
            className = statusMap[status] || 'danger'
            return `badge-${className}`;
        },
        getServiceIcon(status) {
            let iconName;
            const iconsMap = {
                'Success': 'check-circle',
                'Pending': 'circle-o-notch fa-spin',
            }
            iconName = iconsMap[status] || 'exclamation-circle'
            return `fa-${iconName}`;
        },
        setServiceInterval(service) {
            let startTime = Date.now();

            return setInterval(() => {
                var elapsedTime = Date.now() - startTime;
                this.services[service].responseTime = (elapsedTime / 1800).toFixed(3);
            }, 50);
        },
        checkLMDCStatus() {
            const interval = this.setServiceInterval('lmdcAPI');
            
            breedService.getBreeds()
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        clearInterval(interval);
                        this.services.lmdcAPI.status = 'Success';
                    } else {
                        clearInterval(interval);
                        this.services.lmdcAPI.status = 'Failed';
                    }
                });
        },
        checkAuthServiceStatus() {
            const interval = this.setServiceInterval('authServiceAPI');

            authHealthCheckService.getHealthCheck()
				.then(res => {
					if (res.data.status === STATUS_MSG.AUTH_SERVICE_HEALTH_CHECK_SUCCESS_MG) {
                        clearInterval(interval);
                        this.services.authServiceAPI.status = 'Success';
					} else {
                        clearInterval(interval);
                        this.services.authServiceAPI.status = 'Failed';
					}
				});
        },
        checkAddressFinderStatus() {
            const interval = this.setServiceInterval('addressFinderAPI');

            const addressDetails = '1 Martin Street';

            addressFinderAutocompleteService.getAutocompleteAddress(addressDetails)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        clearInterval(interval);
                        this.services.addressFinderAPI.status = 'Success';
                    } else {
                        clearInterval(interval);
                        this.services.addressFinderAPI.status = 'Failed';
                    }
                });
        }
    }
}